<template>
  <div class="file-uploader">
    <el-upload
      ref="fileUploader"
      class="avatar-uploader"
      action="上传路径"
      :limit="3"
      :file-list="fileList"
      :auto-upload="this.autoUpload"
      :http-request="upload"
      :on-change="uploadChange"
      :on-remove="handleRemove"
      :on-exceed="handleExceed"
      :before-upload="beforeAvatarUpload"
    >
      <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
      <div slot="tip" class="el-upload__tip">
        最多只能上传3个图片，且单个文件不超过10MB
      </div>
    </el-upload>
  </div>
</template>

<script>
import { upload } from "@/api/document";
import { apiConfig } from "../config/api";
export default {
  components: {},
  props: {
    uploadDir: {
      type: String,
      default: function() {
        return "";
      }
    },
    list: {
      type: Array,
      default: function() {
        return [];
      }
    },
    autoUpload: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fileList: []
    };
  },
  mounted() {},
  watch: {
    list(val) {
      if (val && val.length > 0 && this.fileList.length === 0) {
        this.loadFileList();
      } else {
        this.fileList = val;
      }
    }
  },
  methods: {
    async loadFileList() {
      this.fileList = [];
      for (let i = 0; i < this.list.length; i++) {
        let item = this.list[i];
        let src = apiConfig.document.api.download.url + item.docId;
        this.fileList.push({
          url: src,
          docId: item.docId,
          name: item.name
        });
      }
    },
    beforeAvatarUpload(file) {
      let isLt2M = file.size / 1024 / 1024 < 10;

      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 10MB!");
      }
      return isLt2M;
    },
    async upload(data) {
      let that = this;

      let param = new FormData(); // 创建form对象
      param.append("file", data.file);
      param.append("filename", data.file.name);
      param.append("dir", this.uploadDir);

      let res = await upload(param, {
        //添加请求头
        headers: { "Content-Type": "multipart/form-data" },
        //添加上传进度监听事件
        onUploadProgress: function(e) {
          console.log("进度：");
          console.log(e);
          //属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
          //如果lengthComputable为false，就获取不到e.total和e.loaded
          if (e.lengthComputable) {
            data.onProgress({ percent: (e.loaded / e.total) * 100 });
          }
        }
      });
      if (res.code === "200") {
        // 上传完成
        data.onSuccess();
        that.fileList = that.fileList.map(item => {
          if (data.file.uid === item.uid) {
            item.name = data.file.name;
            item.docId = res.data.docId;
            item.url = apiConfig.document.api.download.url + res.data.docId;
          }
          return item;
        });
        that.success();
      }
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    handleExceed(files, fileList) {
      this.$message.error(`当前限制选择 3 个文件`);
    },
    uploadChange(file, fileList) {
      if (this.autoUpload) {
        return false;
      }
      let isImage =
        file.raw.type === "image/jpeg" || file.raw.type === "image/png";
      let isLt2M = file.size / 1024 / 1024 < 10;

      if (!isImage) {
        this.$message.error("只能上传png、jpg格式图片!");
        fileList.splice(fileList.length - 1, fileList.length);
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
        fileList.splice(fileList.length - 1, fileList.length);
        return false;
      }
      this.fileList = fileList;
    },
    success() {
      let i = 0;
      this.fileList.forEach(item => {
        if (item.status === "success") {
          i++;
        }
      });
      if (this.fileList.length === i) {
        let newList = this.fileList.map(item => {
          return {
            docId: item.docId,
            name: item.name
          };
        });
        this.$emit("result", newList);
        this.$emit("uploadCallback");
      }
    },
    submit() {
      let i = 0;
      this.fileList.forEach(item => {
        if (item.status === "success") {
          i++;
        }
      });
      if (this.fileList.length === i) {
        let newList = this.fileList.map(item => {
          return {
            docId: item.docId,
            name: item.name
          };
        });
        this.$emit("result", newList);
        this.$emit("uploadCallback");
      } else {
        this.$refs["fileUploader"].submit();
      }
    }
  }
};
</script>

<style lang="scss">
.file-uploader {
}
</style>
